import {
  FILTER_DROPDOWN_CONTENT_MARGIN,
  FILTER_DROPDOWN_GAP,
  FILTER_DROPDOWN_MAX_HEIGHT,
  FILTER_DROPDOWN_VIEWPORT_MARGIN,
  PREVIEW_FILTER_DROPDOWN_MAX_HEIGHT
} from 'src/components/star-grid/filterDropdownConstants';

export const filterDropdownSpace = (trigger: HTMLElement): number => {
  const viewport = window.visualViewport;
  const bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
  return Math.max(0, bottom - trigger.getBoundingClientRect().bottom - FILTER_DROPDOWN_GAP - FILTER_DROPDOWN_VIEWPORT_MARGIN);
};

export const positionFilterDropdown = (trigger: HTMLElement, dropdown: HTMLElement): void => {
  const limit = trigger.closest('[data-filter-preview]') ? PREVIEW_FILTER_DROPDOWN_MAX_HEIGHT : FILTER_DROPDOWN_MAX_HEIGHT;
  const height = Math.min(limit, filterDropdownSpace(trigger));
  dropdown.dataset.filterDropdown = 'true';
  dropdown.style.setProperty('--filter-dropdown-top', `${trigger.getBoundingClientRect().bottom + FILTER_DROPDOWN_GAP}px`);
  dropdown.style.setProperty('--filter-dropdown-max-height', `${height}px`);
  // Flush with the chip's left edge, shifted left only as far as keeps it on screen: from its static
  // spot a chip near the right edge opened the panel past the viewport. Read by our own panel only;
  // Cloudscape places its dropdowns itself.
  const chip = trigger.closest<HTMLElement>('[data-report-filter]') ?? trigger;
  const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
  const width = Math.min(dropdown.getBoundingClientRect().width, viewportWidth - 2 * FILTER_DROPDOWN_VIEWPORT_MARGIN);
  const left = Math.min(chip.getBoundingClientRect().left, viewportWidth - width - FILTER_DROPDOWN_VIEWPORT_MARGIN);
  dropdown.style.setProperty('--filter-dropdown-left', `${Math.max(FILTER_DROPDOWN_VIEWPORT_MARGIN, left)}px`);
  const options = dropdown.querySelector<HTMLElement>('[role="listbox"]');
  const header = options ? Math.max(0, options.getBoundingClientRect().top - dropdown.getBoundingClientRect().top + dropdown.scrollTop) : 0;
  dropdown.style.setProperty('--filter-dropdown-options-height', `${Math.max(0, height - header - FILTER_DROPDOWN_CONTENT_MARGIN)}px`);
};
